import { useState } from "react";
import ModalWindow from "../../../../../../../Components/ModalWindow/ModalWindow"
import InGameRoles from "../../../../../../../Services/Api/InGameRoles.ts";
import { AddToastNotification } from "../../../../../../../Services/ToastNotification/ToastNotificationManager.js";

const AddEditRoleModal = ({editData, setShowAdd, groupId, refresh}) => {
    const inGameRoles = new InGameRoles();

    const [name, setName] = useState(editData ? editData.roleName : "");
    const [discordRoleId, setDiscordRoleId] = useState(editData ? editData.discordRoleId : "");
    const [priority, setPriority] = useState(editData ? editData.priority : 0);
    

    const addEdit = () => {
        if(name && discordRoleId) {
            let data = {
                ServerGroupId : groupId,
                RoleName : name,
                Priority : priority,
                DiscordRoleId : discordRoleId
            };

            if(editData)
            {
                data.Id = editData.id;
                inGameRoles.Edit(data, () => {
                    setShowAdd(false);
                    refresh();
                });
            }  
            else
                inGameRoles.Add(data, () => {
                    setShowAdd(false);
                    refresh();
                });
        }else{
            AddToastNotification("Uzupełnij dane!" , 0);
        }
            
    }

    return (
        <ModalWindow 
            title={editData ? "Edytuj rolę" : "Dodaj rolę"}
            minWidth={"30%"}
            buttons={[
                { Text: editData ? "Edytuj" : "Dodaj", onClick: () => addEdit() }, 
                { Text: "Anuluj", className: "modalSecondaryBtn", onClick: () => setShowAdd(false)}
            ]}
            content={
                <>
                    <div className="modalField">
                        <span className="pl-1">Nazwa roli</span>
                        <input defaultValue={name} onChange={(e) => setName(e.target.value)} className="input w-full" type="text"/>
                    </div>    
                    <div className="modalField">
                        <span className="pl-1">Id roli na discordzie</span>
                        <input defaultValue={discordRoleId} onChange={(e) => setDiscordRoleId(e.target.value)} className="input w-full" type="text"/>
                    </div>                   
                    <div className="modalField">
                        <label>Priorytet</label>
                        <input defaultValue={priority} onChange={(e) => setPriority(e.target.value)} min={0} max={1000} className="input w-full" type="number"/>
                    </div>
                </>
            }
        />
    )
}

export default AddEditRoleModal